<template>
    <div>
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="132.7px"
	 height="177.3px" viewBox="0 0 132.7 177.3" style="enable-background:new 0 0 132.7 177.3;" xml:space="preserve">

<g id="boton4" @click="evaluar()">
	<g>
		
			<image style="overflow:visible;" width="119" height="119" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHcAAAB3CAYAAAA5Od+KAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJ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" transform="matrix(1 0 0 1 6.7456 7.2808)">
		</image>
		<g id="XMLID_2790_">
			<rect id="XMLID_11_" x="10.6" y="140.4" class="st3" width="111.5" height="29.5"/>
			<text transform="matrix(1 0 0 1 23.3071 152.436)"><tspan x="0" y="0" class="st2 st1 st4">Gas o Vapor </tspan><tspan x="18.8" y="17" class="st2 st1 st4">Tóxico</tspan></text>
		</g>
		<linearGradient id="XMLID_3_" gradientUnits="userSpaceOnUse" x1="4.4214" y1="66.7808" x2="128.2456" y2="66.7808">
			<stop  offset="0" style="stop-color:#23CAD9"/>
			<stop  offset="0.9898" style="stop-color:#32ADF0"/>
		</linearGradient>
		<circle id="XMLID_2618_" class="st0" cx="66.3" cy="66.8" r="59.4"/>
	</g>
</g>
<g id="check4" :class="visto ?'mostrar':'esconder'">
	
		<image style="overflow:visible;" width="26" height="26" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJ
bWFnZVJlYWR5ccllPAAAAsVJREFUeNpiYKATYCRGkeTcIAUgFcDwn0EfSCsgSX0AmnARSG94nrzu
AtkWycwPMvj/n6EebAlh8ICRkaHxSeK6BSRZJLsgqB9IFZARSgeAFgY+il/3Aa9FCouDBIC+WA9k
OlAQJR+Aljk+iEUEJxO6CiZGhvnMTAwOQMxAARYAmrNfaWmwAMxcFmRLVJYFNxAZH8QAkCWgkHFE
CTq1lcEKwFR1HqqAJMDLys3Ax8bN8PTrK2zSibci1i5gQgqyfCaQl4EipOJO82yGje7dDFpCCtjk
61F8pLUm+D05vmk1yWEIkIekm8+/vzJ0XFzAsOHhfnRlhuA40lkX7ECOJf5yjnBLYEHICPUJGggA
WwSUMCDVEkdJM4YW42wUsaX3tjJsfrwfm0X2MItI8o06nwJDsyGqJZsfH2DouTofmyWIfIQvT4CC
p8kwB87nZ+dmmG3VCA4mGLj16QFD7/X5eM2B+Qgr8JZ2ZKjXy4YXIX035jPMMEO15Pn31wwZp+oZ
vv39itMceIYFKniALqHKqwC3BAR8ZBwY7CVMGXhZEJZ8+fOVofx8J0FLQEUSE9SiC+jp/+7XBwzb
nh1AzZhIloBAxYUuhjtAdUTktYPwfGS9J/g+Wl0DBmFy3gx5qokYTmy7NpVh2/P9xKYfQ0TJwMSw
EFskrn2ylaH9xlQUXauBYjtf7ieqgAWae+Coy9oLyEXQBGBm+4DN67uAhnbchFi24+UBhml355NS
RDVi1EeOh4IDGCElLlZgLWzGcOHjVYavwERADPjPwLBgv93aRKwVn/ORkH5G8mpWdEsuMPz/77jX
du0HnFW527EQcqtxGLgArKUdd1uv+UCwzeB+PCQAWB3PJ6OwnbDDYk0hSa0gz5MhAkDLQD6Lx5b0
0cACoC8at5uveUB2uw5cMpwOMQA3WBjRfPifAZSrL2wxXfMBn36AAAMAZz7LJ6pPpnwAAAAASUVO
RK5CYII=" transform="matrix(1 0 0 1 96.7456 10.9995)">
	</image>
</g>
</svg>
        <modal-app v-model="modala" :fullscreen="false" width="700px">
            <template slot="modaltittle">
            </template>

            <template slot="modalcontent">
                <v-layout row wrap justify-center align-center>
                    <v-flex xs12 md6>
                        <img class="img-fluid" src="@/assets/unidad1/pantalla-4-5.png" alt="">
                    </v-flex>
                    <v-flex xs12 md6>
                        <h2>Gas o vapor tóxico</h2>
                        <p>Gas o vapor con la <strong>propiedad</strong> de generar daño en la salud de las personas, ya
                            sea por inhalación, ingestión o por vía cutánea. Las sustancia tóxicas tienen definido un
                            TWA, un STEL y un IDLH (niveles permisibles de exposición y su peligrosidad).</p>
                    </v-flex>
                </v-layout>
            </template>
        </modal-app>
    </div>
</template>

<script>
    import nextConditions from "../../../js/mixins/nextConditions";
    export default {
        mixins: [nextConditions],
        // props: {
        //     modala: {
        //         type: Boolean,
        //         default: false
        //     },
        // },
        data() {
            return {
                visto: false,
                modala: false,
            }
        },
        methods: {
            evaluar() {
                this.modala = true;
                this.visto = true;
                this.$store.commit('vistosUnidad1Mod34', this.visto)
                if (this.$store.state.vistosUnidad1Mod31 && this.$store.state.vistosUnidad1Mod32 && this.$store.state
                    .vistosUnidad1Mod33 && this.$store.state.vistosUnidad1Mod34) {
                    this.$store.commit('vistosAllMod3', true)
                }
            }
        },
        mounted() {},
    }
</script>


<style lang="scss" scoped>
    svg {
        cursor: pointer;
    }

    .mostrar {
        display: block;
    }

    .esconder {
        display: none;
    }
	.st0{fill:none;stroke:url(#XMLID_3_);stroke-width:5;stroke-miterlimit:10;}
	.st1{font-family:'FontBase-SemiBold';}
	.st2{fill:#2D2D2D;}
	.st3{fill:none;}
	.st4{font-size:17;}
</style>